import { Link } from 'react-router';
import { Bouton } from '../shared/ui/Bouton';
import { Paragraphe, Section } from '../shared/ui/Section';
import { Titre } from '../shared/ui/Titre';

/**
 * **PAGE 2 DES HUIT — celle qui s'adresse aux STRUCTURES**, F-69.
 *
 * `CDC-6` §1 : « Swype se vend aux structures de soutien scolaire et aux tuteurs
 * indépendants, **jamais aux familles**. » Cette page et la suivante sont les deux moitiés
 * de cette phrase, et **la seule chose qui les sépare est à qui elles parlent** : le
 * produit est le même.
 *
 * **AUCUN TARIF**, F-69, et cette page est celle où la tentation est la plus forte : elle
 * s'adresse à qui achète. « **AUCUN TARIF NULLE PART SUR LE SITE.** Le prix se discute hors
 * du site. » Il n'y a donc ni grille, ni palier, ni « à partir de », ni devis en ligne — le
 * chemin est d'écrire.
 *
 * **RIEN QUI S'ADRESSE À UN PARENT**, brief de maquette : « le site s'adresse aux structures
 * et aux tuteurs, **jamais à un parent** ». Les familles sont nommées ici comme les
 * bénéficiaires d'un service que la structure vend, jamais comme des lecteurs de cette page.
 *
 * **ELLE NE REFUSE AUCUN APPAREIL**, F-73 : « les sept pages qui présentent ne refusent rien
 * et s'adaptent à tout. Le plancher de 1024 points ne lie pas le site qui présente, il lie
 * l'application et la porte qui y mène. »
 */
export function PageStructures() {
  return (
    <>
      <Section largeur="etroite">
        <Titre niveau={1}>Pour une structure de soutien scolaire</Titre>
        <Paragraphe>
          Vous employez des intervenants, vous suivez des élèves, et vous devez
          savoir ce qui a été fait et pendant combien de temps. Swype vous donne
          la salle de cours et la mesure, sans toucher à votre relation avec les
          familles.
        </Paragraphe>
      </Section>

      <Section titre="Ce que vous tenez">
        <div className="grid gap-6 sm:grid-cols-2">
          <div className="flex flex-col gap-2">
            <Titre niveau={3} taille="18">
              Vos comptes, créés par vous
            </Titre>
            <Paragraphe>
              Vous ouvrez les comptes de vos intervenants et de vos élèves, un
              par un ou par un fichier. Personne ne s’inscrit tout seul, et
              aucune famille n’a de compte à créer.
            </Paragraphe>
          </div>
          <div className="flex flex-col gap-2">
            <Titre niveau={3} taille="18">
              Vos élèves ne voient que les vôtres
            </Titre>
            <Paragraphe>
              Une structure ne voit rien d’une autre. Un intervenant ne voit que
              les élèves qu’on lui a confiés, et un élève ne voit que ses
              propres cours.
            </Paragraphe>
          </div>
          <div className="flex flex-col gap-2">
            <Titre niveau={3} taille="18">
              Le temps réellement passé
            </Titre>
            <Paragraphe>
              Chaque entrée et chaque sortie d’un cours sont relevées. Vous
              lisez des durées mesurées, et non des heures déclarées après coup.
            </Paragraphe>
          </div>
          <div className="flex flex-col gap-2">
            <Titre niveau={3} taille="18">
              Vos réglages, pas les nôtres
            </Titre>
            <Paragraphe>
              La durée de relecture d’un cours, le nombre d’élèves par cours et
              la place de vos documents sont des réglages de votre structure.
            </Paragraphe>
          </div>
        </div>
      </Section>

      <Section largeur="etroite" titre="Ce que Swype ne fait pas">
        <Paragraphe>
          Swype ne facture personne, ne prend aucun paiement et n’écrit jamais
          aux familles. Il ne remplace ni votre logiciel de gestion, ni votre
          manière de recruter, ni votre pédagogie : il tient la salle de cours
          et il compte le temps.
        </Paragraphe>
      </Section>

      <Section largeur="etroite" titre="La suite">
        <Paragraphe>
          La mise en place, le périmètre et le prix se discutent de vive voix.
        </Paragraphe>
        <div className="flex flex-wrap gap-3">
          <Link to="/contact">
            <Bouton>Nous écrire</Bouton>
          </Link>
          <Link to="/produit">
            <Bouton variante="faible">Le produit en détail</Bouton>
          </Link>
        </div>
      </Section>
    </>
  );
}
